import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const GOOGLE_SEO_FAQ = [
  {
    title: 'Что такое поведенческие факторы (ПФ) и почему они важны?',
    isH3: true,
    text:
      <div>
        Поведенческие факторы (ПФ) — это действия пользователей на сайте, влияющие на восприятие ресурса поисковыми системами.
        <br />
        <br />
        К ним относятся:
        <br />
        <ul>
          <li>продолжительность сеанса,</li>
          <li>глубина просмотра,</li>
          <li>число возвращений,</li>
          <li>переходы по внутренним ссылкам.</li>
        </ul>
        <br />
        «Хорошие ПФ» могут способствовать повышению позиций сайта при прочих равных условиях.
      </div>
  },
  {
    title: 'Что значит «накрутка ПФ»?',
    isH3: true,
    text:
      <p>
        Под «накруткой ПФ» мы понимаем организованное взаимодействие аудитории с сайтом, включая:
        <br/>
        <br/>
        <ul>
          <li>переход по ключевым запросам,</li>
          <li>изучение контента,</li>
          <li>просмотр нескольких страниц,</li>
          <li>выполнение заданных действий и предоставления отчета теста</li>
        </ul>
        <br />
        Все действия выполняют реальные пользователи, не боты.
      </p>
  },
  /* {
    title: 'Как вы накручиваете поведенческие факторы для Гугла?',
    isH3: true,
    text:
      <p>
        Мы используем реальных пользователей, которые просматривают ваш сайт по заданным параметрам.
        <br />
        Это позволяет избежать искусственной накрутки и получить естественные, безопасные для поисковых систем показатели.
      </p>
  },
  {
    title: 'Безопасно ли пользоваться вашими услугами?',
    isH3: false,
    text:
      <p>
        Да, наши услуги безопасны. Мы используем только проверенные методы, которые не нарушают правила поисковых систем.
      </p>
  },
  {
    title: 'Как долго действует эффект от накрутки в Google?',
    isH3: false,
    text:
      <p>
        Эффект от накрутки сохраняется до тех пор, пока поведение пользователей на вашем сайте более качественное относительно трафика конкурентов, а параметры внешней и внутренней оптимизации не ухудшаются.
      </p>
  },
  {
    title: 'Как заказать услуги?',
    isH3: false,
    text:
      <p>
        Оформите заказ на нашем сайте, указав необходимые параметры. После оплаты исполнители приступят к выполнению заказа.
        <br />
        <br />
        После выполнения каждой задачи вы получите отчет от исполнителя, и его можно будет сравнить с поведением в Яндекс Вебвизоре.
        <br />
        <br />
        Если задача сделана верно, то примите отчет, а если нет, то отправьте на доработку.
      </p>
  },
  {
    title: 'Сколько стоит накрутка поведенческих факторов в Гугл?',
    isH3: false,
    text:
      <p>
        Цена зависит от количества поисковых запросов и конкуренции.
        <br />
        Вы можете рассчитать стоимость проекта в калькуляторе при создании проекта.
      </p>
  }, */
];

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются
  дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
  сценарий начинается для нового исполнителя с поиска товара по сделанному
  скриншоту вашей ссылки.
</p>;

const ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: 'open', iconHome: 'home-open', title: 'Открыть поисковик Google', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: 'search', iconHome: 'home-search', title: 'Набрать поисковый запрос', initialShare: 1 },
  { type: 'ALWAYS.COMPETITORS', icon: 'time', iconHome: 'home-time', title: 'Открыть несколько сайтов из ТОП-10', titleComment: 'не более 10 сек', initialShare: 1 },
  { type: 'ALWAYS.FIND', icon: 'search', iconHome: 'home-search', title: 'Найти сайт в поисковой выдаче Google', initialShare: 1 },
  { type: "ALWAYS.CLICK", icon: 'click', iconHome: 'home-click', title: "Зайти на продвигаемый сайт", initialShare: 1 },

  {
    type: 'EXTRA.DESCRIPTION',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Изучить меню / каталог / услуги / товар',
    titleComment: 'от 3 мин',
    initialShare: 1,
    activityType: 'Изучение',
  },

  {
    type: 'MAIN.INFO',
    icon: 'search',
    iconHome: 'home-search',
    title: 'Почитать информацию о компании',
    initialShare: 1,
    activityType: 'Информация',
  },
  {
    type: 'MAIN.GEO',
    icon: 'people',
    iconHome: 'home-people',
    title: 'Зайти в адреса / контакты / карту',
    initialShare: 0,
    activityType: 'Контакты',
  },
  {
    type: 'MAIN.PHONE',
    icon: 'phone',
    iconHome: '',
    title: 'Копировать номер телефона с сайта',
    titleComment: 'без звонка',
    initialShare: 0,
    activityType: 'Телефон',
  },
  {
    type: 'MAIN.EMAIL',
    icon: 'message',
    iconHome: 'home-message',
    title: 'Копировать на сайте почту из контактов',
    initialShare: 0,
    activityType: 'Почта',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    path: "/nakrutka-pf-google",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-open",
    title: "Открыть поисковик Google",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Набрать поисковый запрос",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-time",
    title: "Открыть несколько сайтов из ТОП-10",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти сайт в поисковой выдаче Google",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Зайти на продвигаемый сайт",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Изучить меню / каталог / услуги / товар",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-people",
    title: "Контакты и адрес",
    path: "/nakrutka-pf-google",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Почитать информацию о компании",
    path: "/nakrutka-pf-google",
    target: '_self',
  }
];

const STEP_PHRASE_2 = ' Укажите ключевые запросы и ссылку на сайт — и начните работу';

const GOOGLE_SEO_KEYWORDS = [
  'Google', 'google', 'Гугл', 'гугл'
];

const CHAIN_PRICE = 14;

class GoogleSeoClass extends Market {

  id = 'googleseo';

  host = 'google.ru';
  url = 'https://www.google.ru/';

  title = 'Google';

  isMarketplace = false;
  isSeo = true;

  icon = "googleseo";
  titlePlaces = 'Google';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  chainsPerDayNormal = 42;

  chainPrice = CHAIN_PRICE;
  chainsMin = 20;
  chainsMax = 1000;

  chainsDefault = 20;

  reviewPrice = 250;

  chainsStep = 10;
  viewsStep = 10;

  keywords = GOOGLE_SEO_KEYWORDS;

  targetLinkComment = 'Укажите тут адрес вашего сайта';
  targetLinkCommentShort = 'Укажите сайт';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/nakrutka-pf-google',
      rating: 0.01,
      title: 'Накрутка ПФ',
      navigateTitle: 'ПФ действия в поисковых системах',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ в Google от ${CHAIN_PRICE} руб. — заказать поведенческие сценарии`,
        description: 'Накрутка ПФ ЛЮДИ в Google — поисковые переходы, просмотры, взаимодействия.',
        canonical: '/nakrutka-pf-google',
      },
      intro: {
        title: 'Накрутка ПФ Google* ↑',
        comment: 'Протестируйте продвижение в Google через поисковые ПФ сценарии от реальных пользователей:',
        points: [
          'Помогает улучшить поведенческие факторы (ПФ)',
          'Способствует повышению позиций в Google',
          'Повышает показатели вовлеченности и интереса к сайту',
          'Может оптимизировать расходы на рекламу',
        ]
      },
      howItWorks: [
        'Настройте параметры активности в соответствие с конкуренцией',
        'Укажите фразы для поиска вашего сайта',
        'Укажите город и прикрепите скриншот целевой страницы',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку'
      ],
      stepPhrase1: 'Настройте параметры для управления пользовательскими сценариями',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Продвижение в Google через действия пользователей',
      titleFAQ: "Вопрос-ответ о накрутке поведенческих факторов в Google",
      faq: GOOGLE_SEO_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем сайте',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ]
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на сайт';
  invalidUrlStr = 'Укажите корректную ссылку на сайт';
}

const GoogleSeo = new GoogleSeoClass();
export default GoogleSeo;
